<div class="images-and-videos-tab-container">
  <div class="section-container" *ngIf="videos.isNotEmpty()">
    <h1 i18n="@@videos">Videos</h1>
    <div class="section-content">
      <div *ngFor="let video of videos">
        <iframe class="content-holder" [src]='getSanitizedVideoUrl(video.url)' title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"></iframe>
      </div>
    </div>
  </div>
  <div class="section-container" *ngIf="images.isNotEmpty()">
    <h1 i18n="@@images">Images</h1>
    <div class="section-content">
      <div *ngFor="let image of images">
        <img src="{{image.url}}" class="content-holder">
      </div>
    </div>
  </div>
  <div class="empty-state" *ngIf="merchant === null || merchant!.images.isEmpty()">
    <div><img src="assets/gallery-empty-state.svg"></div>
    <div class="empty-state-title">
      <p i18n="@@emptyGalleryTab">There is no gallery available yet!</p>
    </div>
    <div class="empty-state-message">
      <p i18n="@@emptyTabsMessage">Will be available soon. We do our best to provide you with the best experience.</p>
    </div>
  </div>
</div>
